import { AssetTransfer } from '../entities/asset-transfer';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { AssetShipment } from '../entities/asset-shipment';


export class AssetShipmentRequest extends BaseRequest {
  
  assetShipment : AssetShipment;

  constructor(userInfo : UserInfo){    
    super(userInfo);
    this.assetShipment = new AssetShipment();
  }

}